(function() {
    'use strict';

    // 1. Khai báo biến cục bộ (Chỉ tồn tại trong khối function này)
    var ANIMATION_CLASS = 'is-visible';
    var TRIGGER_SELECTOR = '.scroll-trigger';

    // 2. Hàm xử lý chính
    var initScrollAnimation = function() {
        // Kiểm tra hỗ trợ
        if ('IntersectionObserver' in window) {
            
            var observer = new IntersectionObserver(function(entries, selfObserver) {
                entries.forEach(function(entry) {
                    if (entry.isIntersecting) {
                        // Thêm class kích hoạt CSS
                        entry.target.classList.add(ANIMATION_CLASS);
                        // Ngừng theo dõi để tối ưu hiệu năng
                        selfObserver.unobserve(entry.target);
                    }
                });
            }, {
                rootMargin: "0px 0px -100px 0px", 
                threshold: 0.1
            });

            var elements = document.querySelectorAll(TRIGGER_SELECTOR);
            elements.forEach(function(el) {
                observer.observe(el);
            });

        } else {
            // Fallback cho trình duyệt cũ
            var elements = document.querySelectorAll(TRIGGER_SELECTOR);
            elements.forEach(function(el) {
                el.classList.add(ANIMATION_CLASS);
            });
        }
    };

    // 3. Kích hoạt logic
    // Gắn vào sự kiện DOMContentLoaded để đảm bảo HTML đã tải xong
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initScrollAnimation);
    } else {
        initScrollAnimation();
    }

})();